import type { Job } from '@mairistem/composants';

/**
 * Job360 lancé par un traitement long à sa fin, lu dans son résultat JSON sous la clé `cle` (ex.
 * identifiantJobPesFacture, identifiantJobChorus de la numérotation d'un bordereau) : null s'il n'en a lancé aucun
 * ou si son résultat n'est pas du JSON.
 */
const getIdentifiantJobLance = (job: Job, cle: string): number | null => {
	try {
		const identifiant = JSON.parse(job.resultat)?.[cle];

		return typeof identifiant === 'number' ? identifiant : null;
	} catch {
		return null;
	}
};

export default getIdentifiantJobLance;
